<!--  -->
<template>
  <div>
    <ul class="lit03">
      <li v-for="item in productNav" :key="item.title">
        <div class="cont_r_b04">
          <div class="cont_r_b05">
            <img :src="item.img" width="158" height="109">
          </div>
          <div class="cont_r_b06">
            <div class="cont_r_b07">
              <p></p>
            </div>
            <div class="cont_r_b09">
              <p></p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <strong>
                    <u>{{item.title}}</u>
                  </strong>
                </span>
              </p>
              <p>
                <span style="font-family:&quot;color:black;">
                  <span></span>
                </span>
                <span style="font-family:&quot;color:black;">
                  <br>
                </span>
              </p>
              <p style="font-family:&quot;color:black;" v-html="item.word"></p>
              <p></p>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      productNav: [
        {
          title: "Цветные металлы",
          word:
            "Латунная чушка/бронзовая чушка/медная чушка<br />Алюминиевый рулон/алюминиевый лист/алюминиевая фольга/<br />корпусообразующий материал，Вторичная свинцовая чушка/вторичная цинковая чушка",
          img: require("../../../assets/img/common/home1.jpg")
        },
        {
          title: "Руды, редкоземельные металлы, ферросплавы",
          word:
            "Хромовая руда/марганцевая руда<br /> Мишметалл<br />Редкоземельный силицидный сплав<br />Металлический кремний<br />Ферроникель/ферросилиций/ферромарганец/ферросиликомарганец/<br />ферромолибден/феррохром/ферротитан/феррованадий",
          img: require("../../../assets/img/common/home2.jpg")
        },
        {
          title: "Углеродное изделие и металлургический уголь",
          word:
            "Электрод<br />Угольный блок/анод/масса электродная/графитовый блок/кальцинированный<br />кокс/науглероживатель<br />Металлургический уголь",
          img: require("../../../assets/img/common/home3.jpg")
        },
        {
          title: "Сырье для медицины и здравоохранения",
          word:
            "Гиперзин-А<br />Чайный экстракт<br />Теафлавин/растворимый чай<br />Экстракт пуэрарии<br />Экстракт расторопши<br />Косточки винограда экстракт<br />Сульфат хондроитина<br />Глюкозамин сульфат калий<br />Глюкозамин гидрохлорид<br />L-карнитин<br />L-тирозин/L-аргинин/альфа-липоевая кислота",
          img: require("../../../assets/img/common/home4.jpg")
        },
        {
          title: "Сырье для химической промышленности",
          word:
            "Диоксид титана/безводный карбонат натрия/фторид алюминия/синтетический криолит",
          img: require("../../../assets/img/common/home5.jpg")
        },
        {
          title: "Сталь и шихта",
          word:
            "Марганцевая чушка/марганцевой чешуйчатый/марганцевой брикет<br />Магниевая чушка/магний гранулированный, кальций гранулированный<br />Порошковая проволока",
          img: require("../../../assets/img/common/home6.gif")
        }
      ]
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/product/productsy.vue